// ** React Imports
import { Fragment } from "react";

// ** Custom Components
import NavbarUser from "./NavbarUser";
import NavbarBookmarks from "./NavbarBookmarks";

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props;
  let hideMenu = new URLSearchParams(location.search).get('hide') == 'menu';
  //if load from iframe
  if (window.self !== window.top){
    hideMenu = true;
  }

  return (   
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center">
        <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
      </div>
      {hideMenu ? '' : <NavbarUser skin={skin} setSkin={setSkin} />}
    </Fragment>
  );
};

export default ThemeNavbar;
